// project import
import erp from './erp';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [erp]
};

export default menuItems;
